module.exports = "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9JzEwMHB4JyB3aWR0aD0nMTAwcHgnICBmaWxsPSIjQTJBMkEyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2NCA2NCIgeD0iMHB4IiB5PSIwcHgiPjxnIGRhdGEtbmFtZT0iTGF5ZXIgOTEiPjxwYXRoIGQ9Ik01MC4yMiw0YTIsMiwwLDAsMC0zLjMxLTEuNTFsLTMyLjQ0LDI4YTIsMiwwLDAsMCwwLDNsMzIuNDQsMjhBMiwyLDAsMCwwLDUwLjIyLDYwWiI+PC9wYXRoPjwvZz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/left-caret.svg
// module id = 1046
// module chunks = 37